<template>
  <div class="dialog-callback">
    <div class="dialog-callback-box"
         v-loading="loading"
         element-loading-text="请稍等...">
      <div v-if="usernone">
        <span>用户不存在,</span>
        <a target="_blank"
           rel="noopener noreferrer"
           href="https://datainside.com.cn/auth/register/"
           class="link">去注册</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogCallback',
  data () {
    return {
      loading: false,
      openId: '',
      userphone: '',
      usernone: false,
    }
  },
  created () {
    let param = this.$route.query || {};
    let code = param.code;
    if (code) {
      //微信登录重定向
      this.getUserInfoByWxCode(param.code);
      return;
    }
    //其它方式访问，跳转微信登录页面
    window.parent.location.reload();
  },
  methods: {
    getUserInfoByWxCode (code) {
      //通过微信code获取用户信息
      this.loading = true;
      this.$request.get('api/Platform/IntegrationUserAuth/getUserByAppId/', { params: { code: code } }).then((response) => {
        if (response.code === '000000') {
          this.filterResponse(response.data);
        } else {
          this.$message.error(response.message);
          window.parent.location.reload();
        }
      })
        .catch((e) => {
          window.parent.location.reload();
          this.$message.error("连接失败！请刷新页面重试！");
        });
    },
    filterResponse (res) {
      if (res.state) {
        //用户存在
        this.openBIUrl(res.links);
      } else {
        this.loading = false;
        //用户不存在
        this.usernone = true;
      }
    },
    openBIUrl (links) {
      if (links && links.length > 0) {
        window.location.href = links[0].url + '?isdialog=1';
      } else {
        alert('没有可使用的系统!');
      }
    }
  }
}
</script>

<style lang="scss">
a.link {
  text-decoration: none;
}

a.link,
a.link:hover {
  color: #42c3af;
}

a.link:hover {
  text-decoration: underline;
}

.dialog-callback {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #ffffff;
  justify-content: center;

  .dialog-callback-box {
    width: 350px;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #404040;
    background-color: #ffffff;
  }
}
</style>